import React, {useEffect, useMemo, useRef, useState} from "react";
import styled from "@emotion/styled";
import useFontStore from "../stores/useFontStore";
import {useMediaQuery} from "react-responsive";
import {PHONE_MAX_WIDTH} from "../utils/constants";
import useAppStore from "../stores/useAppStore";
import useJoystickStore from "../stores/useJoystickStore";
import {cleanName} from "../utils/fontUtils";

const TextContainerStyled = styled.div({
    position: "absolute",
    top: "50%",
    right: "50%",
    width: "90%",
    height: "80px",
    backgroundColor: "transparent",
    fontSize: "62px", //"calc( 12px + (60 – 20) * ( (50vw – 500px) / ( 700 – 400) ))",
    lineHeight: "62px",
    textAlign: "center",
    border: "none",
    transform: "translate(50%, -50%)",
    [`:focus-visible`]: {
        outline: "none"
    },
    [`::after`]: {
        content: "''",
        height: "100%",
        display: "inline-block"
    }
});

function TextContainer() {

    const el = useRef<HTMLDivElement>(null);

    const isDragging = useJoystickStore(state => state.isDragging);

    const holdFontStr = useFontStore(state => state.holdFontStr);
    const prevFontStr = useFontStore(state => state.prevFontStr);
    const currFont = useFontStore(state => state.currFont);
    const currFontStr = useFontStore(state => state.currFontStr);
    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    const [fontStr, setFontStr] = useState(currFontStr);

    useEffect(() => {
        const focusOnLoad = false;
        let i = el.current;
        if (i && focusOnLoad) {
            i.focus();
            document.execCommand("selectAll", false);
        }
    }, []);

    const [isCurrLoaded, setIsCurrLoaded] = useState(false);
    useEffect(() => {
        if(!isDragging) {
            /*console.log(el.current?.style.fontFamily);
            console.log('curr: ', currFont._postscriptName, currFont.isLoaded)*/
            const interval = setInterval(() => {
                if(fontStr !== cleanName(currFont._postscriptName) && currFont.isLoaded) {
                    //console.log('-')
                    clearInterval(interval);
                    setFontStr(cleanName(currFont._postscriptName));
                }
                if(currFont.isLoaded) clearInterval(interval);
            }, 50)

        }
    }, [isDragging, currFont, fontStr]);

    useEffect(() => {
        let hasPrev = document.fonts.check(`12px ${prevFontStr}`);

        if(hasPrev) useFontStore.setState({holdFontStr: prevFontStr});

        let hasHold = document.fonts.check(`12px ${holdFontStr}`);
        let hasCurr = document.fonts.check(`12px ${currFontStr}`);
        /*console.log('--------');
        console.log('hold: ', holdFontStr, hasHold)
        console.log('prev: ', prevFontStr, hasPrev)
        console.log('curr: ', currFontStr, hasCurr)
        console.log('currFont.isLoaded: ', currFont._postscriptName, currFont.isLoaded)
        console.log('--------');*/
        let str = holdFontStr;
        if(currFont.isLoaded) str = cleanName(currFont._postscriptName);
        if(hasPrev) str = prevFontStr;
        if(hasCurr) str = currFontStr;
        setFontStr(str);
        //console.log('str', str);
    }, [holdFontStr, prevFontStr, currFontStr, currFont]);

    return (
        <TextContainerStyled
            ref={el}
            draggable="false"
            onBlur={() => document.getSelection()?.empty()}
            contentEditable
            suppressContentEditableWarning
            style={{
                fontFamily: fontStr,
                fontSize: isPhone ? "36px" : "62px",
                lineHeight: isPhone ? "40px" : "62px",
                transform: isPhone ? "translate(50%, -70%)" : "translate(50%, -50%)"
            }}>
            Your text here
        </TextContainerStyled>
    );
}

export default TextContainer;